//Generated file - DO NOT MODIFY
import { observable, computed, action } from 'mobx';
import { serializable, identifier, update, deserialize } from 'serializr';
import _ from 'lodash';

export default class TimelineEventBase {
    @serializable @observable timelineEventId = '';
    @serializable @observable state = '';
    @serializable @observable order = '';
    @serializable @observable name = '';
    @serializable @observable days = '';
    @serializable @observable weekendsCount = '';
    @serializable @observable holidaysCount = '';
    @serializable @observable canLandOnWeekend = '';
    @serializable @observable canLandOnHoliday = '';
    @serializable @observable exclude = '';
    @serializable @observable reminders = '';
    @serializable @observable recurrences;
    @serializable @observable eventType = '';
    @serializable @observable excludeFromWorkflow = '';
    @serializable @observable excludeFromEmailGrid = '';
    @serializable @observable excludeFromCalendarReminders = '';

    static get __name__() {
        return 'TimelineEvent';
    }

    constructor(
        timelineEventId = '',
        state = '',
        order = '',
        name = '',
        days = '',
        weekendsCount = '',
        holidaysCount = '',
        canLandOnWeekend = '',
        canLandOnHoliday = '',
        exclude = '',
        reminders = '',
        eventType = '',
        excludeFromWorkflow = '',
        excludeFromEmailGrid = '',
        excludeFromCalendarReminders = '',
        recurrences
    ) {
        this.timelineEventId = observable();
        this.timelineEventId = timelineEventId;
        this.state = observable();
        this.state = state;
        this.order = observable();
        this.order = order;
        this.name = observable();
        this.name = name;
        this.days = observable();
        this.days = days;
        this.weekendsCount = observable();
        this.weekendsCount = weekendsCount;
        this.holidaysCount = observable();
        this.holidaysCount = holidaysCount;
        this.canLandOnWeekend = observable();
        this.canLandOnWeekend = canLandOnWeekend;
        this.canLandOnHoliday = observable();
        this.canLandOnHoliday = canLandOnHoliday;
        this.exclude = observable();
        this.exclude = exclude;
        this.reminders = observable();
        this.reminders = reminders;
        this.eventType = observable();
        this.eventType = eventType;
        this.excludeFromWorkflow = observable();
        this.excludeFromWorkflow = excludeFromWorkflow;
        this.excludeFromEmailGrid = observable();
        this.excludeFromEmailGrid = excludeFromEmailGrid;
        this.excludeFromCalendarReminders = observable();
        this.excludeFromCalendarReminders = excludeFromCalendarReminders;
        this.recurrences = observable();
        this.recurrences = recurrences;
    }
}



// WEBPACK FOOTER //
// ./src/shared/timelineevent-base.js